import React from "react";
import { Button } from "reactstrap";
import { formatDateTime, formatDateLong } from './helpers';


/**
 * Transforms a single reference store item for table display
 * @param {Object} store - Reference store object from API
 * @param {number} index - Index for serial number
 * @param {Function} onEdit - Edit handler function
 * @param {Function} onDelete - Delete handler function
 * @returns {Object} Transformed reference store object
 */
export const transformReferenceStoreItem = (store, index, onEdit, onDelete) => ({
    id: index + 1,
    original_id: store.id,
    p_store: store.p_store,
    c_store: store.c_store,
    is_active: store.is_active ? "Active" : "Inactive",
    created_at: formatDateLong(store.created_at),
    updated_at: formatDateLong(store.updated_at),
    action: (
        <span>
            <Button
                className="btn btn-success waves-effect waves-light btn-sm"
                onClick={() => onEdit(store.id, store.p_store, store.c_store, store.created_at, store.updated_at)}
            >
                Edit
            </Button>
            {' '}
            <Button
                className="btn btn-danger waves-effect waves-light btn-sm"
                onClick={() => onDelete(store.id)}
            >
                Delete
            </Button>
        </span>
    )
});

/**
 * Transforms array of reference stores into DataTable format
 * @param {Array} stores - Array of reference store objects from API
 * @param {Array} columns - Table column configuration
 * @param {Function} onEdit - Edit handler function
 * @param {Function} onDelete - Delete handler function
 * @returns {Object} DataTable formatted object with columns and rows
 */
export const transformReferenceStoresToTableData = (stores, columns, onEdit, onDelete) => {
    const rows = stores.map((store, index) => transformReferenceStoreItem(store, index, onEdit, onDelete));

    return {
        columns,
        rows
    };
};

